<template>
  <el-dialog
    title="选择使用期间"
    :visible.sync="dialogVisible"
    width="700px">
    <div>
      <div v-for="(item, index) in periodList" :key="index" class="period-item">
        <el-row :gutter="10" align="middle">
          <el-col :span="4">
            <el-select v-model="item.type" size="mini" placeholder="类型" @change="handleTypeChange(item)">
              <el-option label="单月" value="single"></el-option>
              <el-option label="月份区间" value="range"></el-option>
            </el-select>
          </el-col>
          
          <el-col :span="7" v-if="item.type === 'single'">
            <el-date-picker
              v-model="item.singleDate"
              type="month"
              placeholder="选择月份"
              value-format="yyyy-MM"
              size="mini"
              clearable
              style="width: 100%;">
            </el-date-picker>
          </el-col>
          
          <template v-else>
            <el-col :span="4" style="text-align: center;">
              <span style="font-size: 12px; color: #909399;">开始</span>
            </el-col>
            <el-col :span="5">
              <el-date-picker
                v-model="item.startDate"
                type="month"
                placeholder="开始月份"
                value-format="yyyy-MM"
                size="mini"
                clearable
                style="width: 100%;">
              </el-date-picker>
            </el-col>
            <el-col :span="4" style="text-align: center;">
              <span style="font-size: 12px; color: #909399;">结束</span>
            </el-col>
            <el-col :span="5">
              <el-date-picker
                v-model="item.endDate"
                type="month"
                placeholder="结束月份"
                value-format="yyyy-MM"
                size="mini"
                clearable
                style="width: 100%;">
              </el-date-picker>
            </el-col>
          </template>
          
          <el-col :span="2">
            <el-button 
              v-if="periodList.length > 1" 
              size="mini" 
              type="danger" 
              icon="el-icon-delete"
              @click="removePeriod(index)">
            </el-button>
          </el-col>
        </el-row>
      </div>
      
      <div class="add-button-wrap">
        <el-button size="mini" type="primary" icon="el-icon-plus" @click="addPeriod">添加日期项</el-button>
      </div>
      
      <div class="preview-wrap">
        <span style="color: #909399; font-size: 12px;">
          当前选择：{{ previewText }}
        </span>
      </div>
    </div>
    <div class="period-footer">
      <el-button size="mini" @click="closeFun">取 消</el-button>
      <el-button size="mini" type="primary" @click="confirmFun">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "SelectUsePeriod",
  data() {
    return {
      dialogVisible: false,
      periodList: [],
      callback_fun: undefined
    }
  },
  computed: {
    previewText() {
      if (this.periodList.length === 0) {
        return '未选择'
      }
      const texts = this.periodList.map(item => {
        if (item.type === 'single') {
          return item.singleDate || '未填写'
        } else {
          if (item.startDate && item.endDate) {
            return `${item.startDate}~${item.endDate}`
          } else if (item.startDate) {
            return `${item.startDate}~?`
          } else if (item.endDate) {
            return `?~${item.endDate}`
          }
          return '未填写'
        }
      })
      return texts.join(', ')
    }
  },
  methods: {
    initConfig() {
      this.periodList = [
        {
          type: 'single',
          singleDate: '',
          startDate: '',
          endDate: ''
        }
      ]
      this.callback_fun = undefined
    },
    handleTypeChange(item) {
      item.singleDate = ''
      item.startDate = ''
      item.endDate = ''
    },
    addPeriod() {
      this.periodList.push({
        type: 'single',
        singleDate: '',
        startDate: '',
        endDate: ''
      })
    },
    removePeriod(index) {
      if (this.periodList.length > 1) {
        this.periodList.splice(index, 1)
      }
    },
    show({}, callback_fun) {
      const that = this
      that.initConfig()
      that.dialogVisible = true
      if (typeof callback_fun === 'function') {
        that.callback_fun = callback_fun
      }
    },
    confirmFun() {
      const texts = this.periodList.map(item => {
        if (item.type === 'single') {
          return item.singleDate
        } else {
          if (item.startDate && item.endDate) {
            return `${item.startDate}~${item.endDate}`
          } else if (item.startDate) {
            return `${item.startDate}~?`
          } else if (item.endDate) {
            return `?~${item.endDate}`
          }
          return '未填写'
        }
      })
      
      const result = texts.join(', ')
      
      if (typeof this.callback_fun === 'function') {
        this.callback_fun(result)
        this.callback_fun = undefined
      }
      this.dialogVisible = false
    },
    closeFun() {
      if (typeof this.callback_fun === 'function') {
        this.callback_fun = undefined
      }
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.period-item {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.add-button-wrap {
  margin-top: 15px;
  text-align: center;
}

.preview-wrap {
  margin-top: 15px;
  text-align: center;
  padding: 10px;
  background-color: #ecf5ff;
  border-radius: 4px;
}

.period-footer {
  margin-top: 20px;
  width: 100%;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/Flow/components/SelectUsePeriod.vue